/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const tiptapEditorStyle = {
  tiptapContainer: {
    borderWidth: "0.0625rem",
    borderStyle: "solid",
    borderColor: "grey.400",
    borderRadius: "0.25rem",
  },
  tiptapContainerError: {
    borderColor: "error.main",
  },
  editor: {
    display: "flex",
    "& .tiptap": {
      padding: "0 1rem",
      minHeight: "20rem",
      width: "100%",
      overflowWrap: "break-word",
      wordBreak: "break-word",
      whiteSpace: "pre-wrap",
    },
  },
};
